export default {
  'SAVE_PRODUCTS' (state, payload) {
    state.items = [...state.items, ...JSON.parse(JSON.stringify(payload))]
  },
  'CLEAR_PRODUCTS' (state) {
    state.items = []
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/products/mutations.js